import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfFont,
  PdfBrush,
  PdfColor,
  ETextAlign,
} from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/label';
import '../../pdf/draw/helpers';
import '../../pdf/draw/transforms';

/**
 * Pyramida (Pyramid) - Pyramid number structure
 *
 * Layout: 1 landscape page with 4 rows in pyramid structure (1+2+3+4 = 10 items).
 * Each row has pastel background, items with images and rotated text.
 *
 * Migrated from C# EduFrame.Img10.Generators.Pyramida
 */
export class Pyramida implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 10;
  }
  countMax(): number {
    return 10;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const page = pdf.addPage(true); // landscape

    const margin = PdfUnit.FromMillimeters(20);
    const rowWidth = PdfSize.A4.height - 2 * margin; // A4H width
    const rowHeight = (PdfSize.A4.width - 2 * margin) / 4; // A4H height / 4

    // Adjust font for all right-side label texts
    const allTexts = opts.list.map((t) => t.right.getText() ?? '').filter((t) => t);
    const labelFont =
      allTexts.length > 0 ? page.adjustFont(rowHeight, allTexts, GUtil.baseFont) : GUtil.baseFont;

    let index = 0;
    for (let i = 0; i < 4; i++) {
      const rect = new PdfRect(margin, margin + rowHeight * i, rowWidth, rowHeight);

      // Pastel background
      if (i < GUtil.pastelColors.length) {
        page.drawRectangle(null, new PdfBrush(GUtil.pastelColors[i]), rect);
      }

      const spacing = 50;
      for (let j = 0; j <= i; j++) {
        if (index >= opts.list.length) break;

        const cellX =
          rect.centerX - ((i + 1) * (rowHeight + spacing)) / 2 + j * (rowHeight + spacing);
        const r = new PdfRect(cellX, rect.y, rowHeight, rowHeight);

        page.drawLabel(opts.list[index].left, { rect: r });

        // Rotated text to the right
        const r1 = new PdfRect(r.x + rowHeight / 2 + 15, r.y, r.width, r.height);
        const center = new PdfPoint(r1.centerX, r1.centerY);

        page.save();
        page.rotateAtTransform(-90, center);
        const rightText = opts.list[index].right.getText() ?? '';
        if (rightText) {
          page.drawFillStringCenter(rightText, labelFont, PdfBrush.Black, r1);
        }
        page.restore();

        index++;
      }
    }
  }
}
